import React, { Component } from 'react'
import {connect} from 'react-redux'
import moment from 'moment'

import { money } from '../Utils/Service'

import { deleteBalance } from '../../actions/Balance'

import Modal from '../Modal'

class DeleteBalance extends Component {
  deleteBalance () {
    this.props.deleteBalance({ id: this.props.b.id })
  }
  render () {
    const { ajaxStatus } = this.props.balance
    const b = this.props.b
    return (
      <Modal>
        <h3>Eliminare movimento</h3>
        <button
          className="lnk-close-modal"
          onClick={() => this.props.hideModal()}
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </button>
        <ul className="delete-list">
          <li>
            <span>Numero</span>
            {b.number}
          </li>
          <li>
            <span>Emessa da</span>
            {b.emitter}
          </li>
          <li>
            <span>Data</span>
            {moment.unix(b.emission_date).format('ll')}
          </li>
          <li>
            <span>Importo</span>
            {money(b.amount)}
          </li>
        </ul>
        <ul className="submit-btn">
          <li>
            <span className="ajax-error">{ajaxStatus}</span>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.props.hideModal()}
            >
              annulla
            </button>
          </li>
          <li>
            <button
              className="lnk-submit"
              onClick={() => this.deleteBalance()}
            >
              elimna
            </button>
          </li>
        </ul>
      </Modal>
    )
  }
}

function mapStateToProps (state) {
  return state
}

export default connect(mapStateToProps, { deleteBalance })(DeleteBalance)



// WEBPACK FOOTER //
// ./src/components/Balance/DeleteBalance.js